export const controllersNames = {
    news: 'News',
    comments: 'Comments',
    users: 'Users',
    categories: 'Categories',
    parentCategories: 'ParentCategories',
    payment: 'Payment',
    auth: 'Auth',
    homepage: 'Homepage',
    adminUrls: 'AdminUrls',
    tags: 'Tags',
    crypto: 'Crypto',
    game: 'Game',
    courses: 'Courses',
    settings: 'Settings',
    userscripts: 'UserScripts',
    calculatorParams: 'CalculatorParams',
    emailTemplates: 'EmailTemplates'

}
